import { Route, Routes } from 'react-router-dom';

import History from '../pages/History';
import Home from '../pages/Home';
import Loading from '../pages/Loading';
import Login from '../pages/Login';
import Payment from '../pages/Payment';
import Profile from '../pages/Profile';
import Result from '../pages/Result';
import Setting from '../pages/Setting';
import Success from '../pages/Success';

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/loading" element={<Loading />} />
      <Route path="/result" element={<Result />} />
      <Route path="/login" element={<Login />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/history" element={<History />} />
      <Route path="/setting" element={<Setting />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/success" element={<Success />} />
    </Routes>
  );
};

export default AppRouter;
